jQuery(document).ready(function($) {

  $("body").addClass("preloading");
  $("body").prepend('<div id="preloader"><div id="circle"></div><h2>Loading Experience</h2></div>');

	window.addEventListener('load', function() {
		$("body").removeClass("preloading").addClass("loaded");
	});

  enquire.register("screen and (min-width:1025px)", {

    match : function() {

      $('.main-science-page').append('<div id="dfndr-vid"><iframe id="video-whole" src="https://player.vimeo.com/video/316920369?background=1&loop=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>');

      $('#dfndr-vid iframe').css('opacity','1'); // to hide it when autoplays

      var iframe1 = document.querySelector('#video-whole');
      var player1 = new Vimeo.Player(iframe1);

      player1.pause();

      //player1.addCuePoint(0, { customKey: 'pauseVimeo' });
      player1.addCuePoint(16, { customKey: 'pauseVimeo' });
      player1.addCuePoint(24, { customKey: 'pauseVimeo' });
      player1.addCuePoint(28, { customKey: 'pauseVimeo' });
      player1.addCuePoint(37, { customKey: 'pauseVimeo' });
      player1.addCuePoint(44, { customKey: 'pauseVimeo' });
      player1.addCuePoint(48, { customKey: 'pauseVimeo' });
      player1.addCuePoint(56.5, { customKey: 'pauseVimeo' });
      player1.addCuePoint(61, { customKey: 'pauseVimeo' });
      player1.addCuePoint(69, { customKey: 'pauseVimeo' });

      player1.on('cuepoint', function(data) { switch (data.data.customKey) { case 'pauseVimeo': this.pause(); } });

      player1.addCuePoint(59.03, { customKey: 'bg-change' });
      player1.on('cuepoint', function(data) { switch (data.data.customKey) { case 'bg-change': $('#dfndr-vid').addClass('white-bg'); } });


      var setup_positions = (function() {

          anime.set(['#fast','#deadly','#thats-why','#most-advanced'], { translateX: '100vw'} );
          anime.set(['.intro-para'], { opacity: 0 } );

      });

      setup_positions();

      var scene_1_timeline = anime.timeline({
          targets: ['#avg-speed','#fast','#deadly','#thats-why','#most-advanced','.intro-para','#scroll-cta'],
          easing: 'easeInOutQuart', // global easing
          duration: 1000, // global duration of animations
          loop: false,
          autoplay: false,
          complete: function() { this.pause() }
      });

     /* scene_1_timeline
          .add({ targets: '#avg-speed', opacity: 1 })
          .add({ targets: '#avg-speed',translateY: '-100vh', duration: 800 }, '+=5000')
          .add({ targets: '#fast', translateX: '0vw', duration: 800 })
          .add({ targets: '#deadly', translateX: '0vw', duration: 800 })
          .add({ targets: '#fast , #deadly', translateX: '-100vw', duration: 800}, '+=5000')
          .add({ targets: '#thats-why', translateX: '0vw', duration: 800 }, '-=500')
          .add({ targets: '#thats-why', translateX: '-100vw', duration: 800 }, '+=4000')
          .add({ targets: '#most-advanced', translateX: '0vw', duration: 800 }, '-=500')
          .add({ targets: '#most-advanced', opacity: 0, duration: 800 }, '+=4000')
          .add({ targets: '.intro-para , #scroll-cta', opacity: 1, duration: 800 }, '+=1500')
      ;*/
      
      scene_1_timeline
          .add({ targets: '#avg-speed', opacity: 1 })
          .add({ targets: '#avg-speed',translateY: '-100vh', duration: 900 }, '+=4000')
          .add({ targets: '#fast', translateX: '0vw', duration: 1000 })
          .add({ targets: '#deadly', translateX: '0vw', duration: 1000 })
          .add({ targets: '#fast , #deadly', translateX: '-100vw', duration: 1000}, '+=3000')
          .add({ targets: '#thats-why', translateX: '0vw', duration: 1000 }, '-=500')
          .add({ targets: '#thats-why', translateX: '-100vw', duration: 1000 }, '+=2000')
          .add({ targets: '#most-advanced', translateX: '0vw', duration: 1000 }, '-=500')
          .add({ targets: '#most-advanced', opacity: 0, duration: 1000 }, '+=3000')
          .add({ targets: '.intro-para , #scroll-cta', opacity: 1, duration: 2000 }, '+=1500')
      ;


      var scene_2_timeline = anime.timeline({
          targets: ['#scene2 .txt-block'],
          easing: 'easeInOutQuart', // global easing
          duration: 1000, // global duration of animations
          loop: false,
          autoplay: false,
          complete: function() { this.pause() }
      });

      $('#ani-container').fullpage({

        licenseKey: 'C1CCBB21-13EF4D4C-A36BA536-EDE42815',

        autoScrolling:true,
        scrollHorizontally: false,
        scrollBar: false,

        navigation: true,
        navigationPosition: 'right',
        showActiveTooltip: false,

        fixedElements: 'headers, .footer',

        sectionSelector: '.scene',

        afterLoad (anchorLink, index){

          if ( $("#scene1").is(".active")){
            $('#dfndr-vid , #fp-nav').attr('class', '').addClass('sc-1-active');

            player1.pause();
            player1.setCurrentTime(0.3);
            player1.play();

            scene_1_timeline.restart();

            $('#scroll-cta h2').addClass('on');
            $('#scroll-arrow').addClass('full-opac');

            introScrollPause();

          } else if ( $("#scene2").is(".active")) {
            $('#dfndr-vid, #fp-nav').attr('class', '').addClass('sc-2-active');

            player1.pause();
            player1.setCurrentTime(21);
            player1.play();

            $('#scroll-cta h2').removeClass('on').addClass('off');
            $('#scroll-arrow').removeClass('full-opac').addClass('half-opac');

          } else if ( $("#scene3").is(".active")) {
            $('#dfndr-vid, #fp-nav').attr('class', '').addClass('sc-3-active');

            player1.pause();
            player1.setCurrentTime(26.5);
            player1.play();

          } else if ( $("#scene4").is(".active")) {
            $('#dfndr-vid, #fp-nav').attr('class', '').addClass('sc-4-active');

            player1.pause();
            player1.setCurrentTime(33.2);
            player1.play();

          } else if ( $("#scene5").is(".active")) {
            $('#dfndr-vid, #fp-nav').attr('class', '').addClass('sc-5-active');

            player1.pause();
            player1.setCurrentTime(38.2);
            player1.play();

          } else if ( $("#scene6").is(".active")) {
            $('#dfndr-vid, #fp-nav').attr('class', '').addClass('sc-6-active');

            player1.pause();
            player1.setCurrentTime(45.5);
            player1.play();

          } else if ( $("#scene7").is(".active")) {
            $('#dfndr-vid, #fp-nav').attr('class', '').addClass('sc-7-active');

            player1.pause();
            player1.setCurrentTime(51.4);
            player1.play();

          } else if ( $("#scene8").is(".active")) {
            $('#dfndr-vid, #fp-nav').attr('class', '').addClass('sc-8-active');
            $('#scroll-cta').addClass('invert');
            $('body').addClass('white-bg');

            player1.pause();
            player1.setCurrentTime(57);
            player1.play();

          } else if ( $("#scene9").is(".active")) {
            $('#dfndr-vid, #fp-nav').attr('class', '').addClass('sc-9-active white-bg');
            $('body').addClass('white-bg');

            player1.pause();
            player1.setCurrentTime(67.4);
            player1.play();

            $('#scenes10-13_proxy').removeClass('sc-10-active sc-11-active');

          } else if ( $("#scene10").is(".active")) {

            $('#vid-9').css('opacity','0');
            $('#scenes10-13_proxy').addClass('sc-10-active').removeClass('sc-11-active');
            $('#fp-nav').attr('class', '').addClass('sc-10-active');
            $('body').addClass('white-bg');

          } else if ( $("#scene11").is(".active")) {
            $('#scenes10-13_proxy').addClass('sc-11-active').removeClass('sc-12-active sc-13-active');
            $('#fp-nav').attr('class', '').addClass('sc-11-active');
            $('body').addClass('white-bg');

          } else if ( $("#scene12").is(".active")) {
            $('#scenes10-13_proxy').addClass('sc-12-active').removeClass('sc-13-active');
            $('#fp-nav').attr('class', '').addClass('sc-12-active');
            $('body').addClass('white-bg');

          } else if ( $("#scene13").is(".active")) {
            $('#scenes10-13_proxy').addClass('sc-13-active').removeClass('sc-11-active sc-12-active sc-14-active');
            $('#fp-nav').attr('class', '').addClass('sc-13-active');
            $('body').addClass('white-bg');

          } else if ( $("#scene14").is(".active")) {
            $('#scenes10-13_proxy').addClass('sc-14-active').removeClass('sc-12-active sc-13-active sc-15-active');
            $('#fp-nav').attr('class', '').addClass('sc-14-active');
            $('body').addClass('white-bg');

          } else if ( $("#scene15").is(".active")) {
            $('#scenes10-13_proxy').addClass('sc-15-active').removeClass('sc-14-active sc-16-active');
            $('#fp-nav').attr('class', '').addClass('sc-15-active');
            $('body').removeClass('show-footer');
            $('body').addClass('white-bg');
            $('#scroll-cta').removeClass('hide').addClass('invert');

          } else if ( $("#scene16").is(".active")) {
            $('#scenes10-13_proxy').addClass('sc-16-active');
            $('#fp-nav').attr('class', '').addClass('sc-16-active');
            $('body').addClass('show-footer');
            $('#scroll-cta').addClass('hide');


          } else {

          }
        }

        ,
        onLeave: function(origin, destination, direction){
            var leavingSection = this;

            //index 6 = Scene7
            if(origin.index == 6 && direction =='down'){

            }
            //index 8 = Scene9
            if(origin.index == 8 && direction =='down'){
                $('#scene9').addClass('goingDown').removeClass('goingUp');
                $('#dfndr-vid').addClass('exitTop');
                $('#scenes10-13_proxy').addClass('sc-10-active');
            }
            else if(origin.index == 8 && direction == 'up'){
                $('#scene9').addClass('goingUp').removeClass('goingDown');
                setTimeout(function(){
                  $('#dfndr-vid').removeClass('white-bg');
                }, 400);
            }

            //index 9 = Scene10
            if(origin.index == 9 && direction =='down'){
                $('#scene10').addClass('goingDown').removeClass('goingUp');

            }
            else if(origin.index == 9 && direction == 'up'){
                $('#scene10').addClass('goingUp').removeClass('goingDown');
            }

            //index 14 = Scene15
            if(origin.index == 14 && direction =='down'){
                $('body').addClass('show-footer');
                $('#scenes10-13_proxy').addClass('hide');
            }

            //index 15 = Scene16
            if(origin.index == 15 && direction =='up'){
                $('body').removeClass('show-footer');
                $('#scenes10-13_proxy').removeClass('hide');
            }

        }

      });

      function introScrollPause() {

        fullpage_api.setAllowScrolling(false);

        setTimeout(function(){
          fullpage_api.setAllowScrolling(true);
        }, 16000);

      }

      $('#scroll-arrow').on('click', function(){
        fullpage_api.moveSectionDown();
      });


      window.addEventListener('load', function() {
        scene_1_timeline.restart();
      });

    },
    unmatch : function() {
		    function refreshonce(){
          location.reload();
        }
        setTimeout(refreshonce, 50);
      },

  });

  enquire.register("screen and (max-width:1024px)", {

    match : function() {

      $(window).scroll(function () {
          var scrollTop = $(window).scrollTop();
          var height = $('.scroll').height();

          $('.scroll').css({
              'opacity': ((height - scrollTop) / height)
          });
      });

      $('#avg-speed').wrap('<div class="scene one-a"></div>');
      $('#fast , #deadly').wrapAll('<div class="scene one-b"></div>');
      $('.intro-para').wrapAll('<div class="scene one-c"></div>');
      $('.scene.one-a').append('<h3 class="scroll">SCROLL</h3>');
      $('.scene.one-b').append('<img class="gif" src="https://cdn.shopify.com/s/files/1/0446/7854/5575/files/11.gif?v=1597751707"/>');
      $('#scene2').prepend('<img class="gif" src="https://cdn.shopify.com/s/files/1/0446/7854/5575/files/12.gif?v=1597751720"/>');
      $('#scene3').prepend('<img class="gif" src="https://cdn.shopify.com/s/files/1/0446/7854/5575/files/13.gif?v=1597751728"/>');
      $('#scene4').prepend('<img class="gif" src="https://cdn.shopify.com/s/files/1/0446/7854/5575/files/14.gif?v=1597751736"/>');
      $('#scene5').prepend('<img class="gif" src="https://cdn.shopify.com/s/files/1/0446/7854/5575/files/15.gif?v=1597751748"/>');
      $('#scene6').prepend('<img src="https://cdn.shopify.com/s/files/1/0446/7854/5575/files/16.jpg?v=1597751755"/>');
      $('#scene7').prepend('<img src="https://cdn.shopify.com/s/files/1/0446/7854/5575/files/17.jpg?v=1597751761"/>');
      $('#scene8').prepend('<img src="https://cdn.shopify.com/s/files/1/0446/7854/5575/files/18.png?v=1597751772"/>');
      $('#scene9').prepend('<img src="https://cdn.shopify.com/s/files/1/0446/7854/5575/files/19.png?v=1597751795"/>');
      $('.scene img').wrap('<div class="graphic-container">');

      $('#scene10').append($('#scenes10-13_proxy .txt-block'));
      $('#scene11').append($('#scenes10-13_proxy .image-block'));
      $('#scene12').append($('.sc-12-img'));
      $('#scene13').append($('.sc-13-img'));
      $('.sc-12-img').prepend($('.sc-12-txt'));
      $('.sc-13-img').prepend($('.sc-13-txt'));

      $('#armor').prependTo($('#scene15'));
    },
    unmatch : function() {
		    function refreshonce(){
          location.reload();
        }
        setTimeout(refreshonce, 50);
      },

  });

});